module.exports = "#entity .content {\n  overflow: hidden; }\n\n.add-entity-button.fixed {\n  position: fixed; }\n"